module.exports = __webpack_public_path__ + "img/begin-in-coffeeMug.f98f68cd.jpg";